import { IELTData } from 'legacy/lut/components/widgets/public/partner360/ELT'

import { IFinancialCockpitEltDocument } from '../../api/types'

export const mapSavedEltDocumentToCockpitShape = (
  source: IELTData
): IFinancialCockpitEltDocument => {
  const document = { ...source }
  delete (document as Partial<IELTData>).FormData

  return document
}
